import { useSite } from '../../contexts/SiteContext';
import { euro } from '../../core/format/currency';

/** De cadeautreden onder elkaar: bedrag links, cadeau rechts. Gedeeld door home en protocollen. */
export function GiftTierList({
  className = 'mt-4'
}: {
  className?: string;
}) {
  const {
    giftTiers
  } = useSite();
  if (giftTiers.length === 0) return null;
  return <ul className={`${className} divide-y divide-line border-y border-line`} aria-label="Cadeaus bij je bestelling" data-id="element-8273" data-mp="2gjzk25krn7c7">
      {giftTiers.map(tier => <li key={tier.threshold} className="flex gap-4 py-3.5" data-id="element-8274" data-mp="26twivi3hqn2s">
          <span className="w-14 shrink-0 type-name text-clay" data-id="element-8275" data-mp="26slat630it5v">
            <span className="sr-only" data-id="element-8276" data-mp="22tm87s4r78hl">Vanaf </span>
            {euro(tier.threshold)}
          </span>
          <span className="text-[14px] leading-snug text-muted" data-id="element-8277" data-mp="1xvb0bmy0r820">
            <span className="block text-ink" data-id="element-8278" data-mp="1sv6le1creldw">{tier.title}</span>
            {tier.description}
          </span>
        </li>)}
    </ul>;
}